import api from './api';

const resource = 'LoginLog/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

const loginLogApi = { list };

export default loginLogApi;
